import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { useStore, useStoreActions } from "../../contexts";
import { Typography, TextButton } from 'seagull';
import { Checkmark } from 'seagull/icons';
import { selectors } from "../../store/state-selectors";
import MobileNotSupportedLayout from "./MobileNotSupportedLayout";
export const MobileNotSupportedScreen = () => {
  var _useLocation;

  const userEmail = useStore(selectors.user.email);
  const {
    api,
    logBI
  } = useStoreActions();
  const [actionStatus, setActionStatus] = useState('pending'); // we show this when a vendor tries to log-in from an email confirmation link, and while on mobile

  const {
    afterEmailVerification
  } = ((_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.state) || {
    afterEmailVerification: false
  };

  async function handleSendLink() {
    logBI(10577);

    try {
      setActionStatus('pending');
      await (afterEmailVerification ? api.user.sendVendorOnboardingLink(userEmail) : api.auth.issueOneTimeAccessLink(userEmail));
      setActionStatus('completed');
    } catch (e) {
      setActionStatus('failed');
    }
  }

  return /*#__PURE__*/React.createElement(MobileNotSupportedLayout, {
    testid: afterEmailVerification ? 'nomobile-after-email-verification' : 'nomobile-screen',
    variant: afterEmailVerification ? 'afterEmail' : 'default',
    content: userEmail ? /*#__PURE__*/React.createElement(React.Fragment, null, afterEmailVerification ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "Sign in to your account on your laptop or desktop to complete profile setup."), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(TextButton, {
      disabled: actionStatus === 'completed',
      onClick: handleSendLink,
      "data-testid": "send-link-to-email"
    }, "Click here"), ' ', "to send yourself a link to Anchor.")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "Anchor is best on a laptop or desktop."), /*#__PURE__*/React.createElement(Typography, null, "Click", ' ', /*#__PURE__*/React.createElement(TextButton, {
      disabled: actionStatus === 'completed',
      onClick: handleSendLink,
      "data-testid": "send-link-to-email"
    }, "here"), ' ', "to send yourself an email with a one time access link to Anchor.")), actionStatus === 'completed' && /*#__PURE__*/React.createElement(Typography, {
      skin: "success",
      "data-testid": "link-send-success"
    }, /*#__PURE__*/React.createElement(Checkmark, {
      style: {
        display: 'inline'
      }
    }), " An email has been sent with a dedicated link."), actionStatus === 'failed' && /*#__PURE__*/React.createElement(Typography, {
      skin: "error",
      "data-testid": "link-send-failure"
    }, "Failed to send a link, please try again")) : null
  });
};